import { render, staticRenderFns } from "./PhoneManage.vue?vue&type=template&id=1a4439fc&scoped=true"
import script from "./PhoneManage.vue?vue&type=script&lang=js"
export * from "./PhoneManage.vue?vue&type=script&lang=js"
import style0 from "./PhoneManage.vue?vue&type=style&index=0&id=1a4439fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4439fc",
  null
  
)

export default component.exports